import type { DecoratedTaskTemplate, DueIn } from '@witmetrics/utils';
import { searchByKeys } from '@witmetrics/utils/arrays';
import { DEADLINE_LABEL } from '@witmetrics/utils/constants';
import { DEADLINE_KEYS } from './constants';

export const classes = {
  paper: 'fixed top-8 rounded-2xl',
  wrapper: 'flex flex-col w-[90vw] max-w-[500px] min-w-[200px] min-h-0',
  inputBase: 'w-full text-2xl px-6 py-4 flex-0',
  resultsList: 'flex-0 max-h-[40vh] overflow-auto',
  message: 'text-grey-7 dark:text-mauve-2 text-center text-lg py-8',
};

export function formatDueIn(dueIn: DueIn): string {
  if (DEADLINE_KEYS.has(dueIn)) {
    return DEADLINE_LABEL[dueIn as keyof typeof DEADLINE_LABEL];
  }
  const [count, unit] = dueIn.split('_');
  const unitLower = unit.toLowerCase();
  const singular = count === '1' ? unitLower.replace(/s$/, '') : unitLower;
  return `${count} ${singular}`;
}

export function filterTemplates(
  templates: DecoratedTaskTemplate[],
  query: string
) {
  return searchByKeys(templates, ['description'], query);
}
